export const ringraziamentiConsiglioMilano2025 = {
  id: 'static-ringraziamenti-milano-2025',
  slug: 'ringraziamenti-consiglio-milano-2025',
  title: 'Ringraziamenti Consiglio Milano 2025',
  excerpt: 'Cari Associati, è con grande soddisfazione che vi scrivo per ringraziarvi del successo straordinario del Consiglio Nazionale tenutosi a Milano.',
  body: `
    <h2>Lettera di Ringraziamento del Segretario</h2>
    
    <p><strong>Cari Associati,</strong></p>
    
    <p>È con grande soddisfazione e orgoglio che mi rivolgo a voi per ringraziarvi del <strong>successo straordinario</strong> del Consiglio Nazionale UNASCA tenutosi a Milano il 25 maggio 2025.</p>
    
    <h3>Un Evento Memorabile</h3>
    
    <p>La vostra partecipazione numerosa e attiva ha reso questo evento un momento fondamentale per la nostra associazione. La qualità degli interventi, il confronto costruttivo e l'entusiasmo dimostrato sono stati davvero encomiabili.</p>
    
    <h3>Risultati Raggiunti</h3>
    
    <p>Grazie al vostro contributo, siamo riusciti a:</p>
    
    <ul>
      <li><strong>Definire le linee guida</strong> per il prossimo biennio</li>
      <li><strong>Approvare nuove iniziative</strong> di formazione e supporto</li>
      <li><strong>Rafforzare la rete</strong> tra le autoscuole associate</li>
      <li><strong>Stabilire collaborazioni</strong> con istituzioni e partner strategici</li>
    </ul>
    
    <h3>Impegni Futuri</h3>
    
    <p>Come Segreteria UNASCA, ci impegniamo a:</p>
    
    <ol>
      <li>Dare seguito a tutte le proposte emerse durante il Consiglio</li>
      <li>Mantenere una comunicazione costante e trasparente</li>
      <li>Organizzare eventi formativi di qualità</li>
      <li>Rappresentare al meglio gli interessi delle autoscuole italiane</li>
    </ol>
    
    <h3>Ringraziamenti Speciali</h3>
    
    <p>Un ringraziamento particolare va a:</p>
    
    <ul>
      <li>Tutti i <strong>partecipanti</strong> che hanno contribuito attivamente ai lavori</li>
      <li>I <strong>relatori</strong> che hanno condiviso la loro esperienza e competenza</li>
      <li>Lo staff del <strong>Quark Hotel</strong> per l'eccellente ospitalità</li>
      <li>Il <strong>team organizzativo</strong> UNASCA per l'impeccabile coordinamento</li>
    </ul>
    
    <h3>Conclusione</h3>
    
    <p>Sono certo che, lavorando insieme con lo stesso spirito di collaborazione dimostrato a Milano, riusciremo a raggiungere tutti gli obiettivi che ci siamo prefissati.</p>
    
    <p>Vi aspetto ai prossimi appuntamenti UNASCA!</p>
    
    <p><strong>Con stima e gratitudine,</strong></p>
    <p><em>Il Segretario UNASCA</em></p>
  `,
  featuredImage: '/images/grazie_milano.png',
  category: {
    id: 'lettera-segretario',
    name: 'Lettera del Segretario',
    slug: 'lettera-del-segretario',
    color: '#10B981'
  },
  tags: ['Ringraziamenti', 'Consiglio Nazionale', 'Milano', 'Lettera del Segretario'],
  author: {
    id: 'unasca-segretario',
    username: 'Segretario UNASCA',
    profile: {
      firstName: 'Segretario',
      lastName: 'Generale',
      fullName: 'Segretario Generale UNASCA'
    }
  },
  status: 'PUBLISHED' as const,
  visibility: 'PUBLIC' as const,
  publishedAt: '2025-05-27T09:00:00Z',
  createdAt: '2025-05-27T09:00:00Z',
  updatedAt: '2025-05-27T09:00:00Z',
  metadata: {
    views: 189,
    likeCount: 24,
    shares: 8
  },
  readingTime: 4
};

